import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";

class DeleteTemplateScriptDialog extends React.PureComponent {
  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.props.onHide}
        size="xs"
        title={t("SingleInstanceTemplate.ScriptsTab.DeleteModal.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={this.props.onSubmit}
        leftButtonVariant="red"
        leftButtonText={t("SingleInstanceTemplate.ScriptsTab.DeleteModal.Confirm")}
        rightButtonCallback={this.props.onHide}
        rightButtonText={t("DialogCancel")}
        rightButtonVariant="black"
        body={
          (<p>
            {t("SingleInstanceTemplate.ScriptsTab.DeleteModal.Text", {
              templateScriptName: this.props.templateScriptName
            })}
          </p>)
        }
      />
    );
  }
}

export default withTranslation()(DeleteTemplateScriptDialog);
